import { Component } from '@angular/core';
import { SocialMediaWidgetSvgSpriteComponent } from './socail-media-widget-svg-sprite.component';
import { TenantService } from '../../services/tenant.service';
import { TenantInfo } from '../../models/tenant.model';
import { AppState } from '../../store';
import { select, Store } from '@ngrx/store';
import { selectTenantInfo } from '../../store/selectors';
import { SocialMediaBarConfig } from '../../models/social-media-bar-config.model';
import { NgClass, NgFor, NgIf } from '@angular/common';

@Component({
  selector: 'social-media-widget',
  standalone: true,
  imports: [SocialMediaWidgetSvgSpriteComponent , NgClass , NgFor , NgIf],
  templateUrl: './social-media-widget.component.html',
  styleUrl: './social-media-widget.component.scss'
})
export class SocialMediaWidgetComponent {

  socialMediaBar: SocialMediaBarConfig;

  constructor(
    private tenant: TenantService,
    private store: Store<AppState>,
  ) { }

  ngOnInit() {

    this.store.pipe(select(selectTenantInfo)).subscribe((tenant) => {
      this.socialMediaBar = tenant.socialMediaBarConfig;
      console.log('Updated social media config:', this.socialMediaBar);
    });
  

  }

  getPlatformClass(platformName: string): string {
    switch (platformName) {
      case 'Facebook':
        return 'bg-1';
      case 'Twitter':
        return 'bg-2';
      case 'Instagram':
        return 'bg-3';
      case 'LinkedIn':
        return 'bg-4';
      case 'Pinterest':
        return 'bg-5';
      case 'WhatsApp':
        return 'bg-6';
      case 'Email':
        return 'bg-7';
      case 'Settings':
        return 'bg-8';
      default:
        return ''; 
    }
  }

}
